var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserChromeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_2110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.042 35.2223C27.5169 35.2223 35.1979 27.5413 35.1979 18.0664C35.1979 8.59139 27.5169 0.9104 18.042 0.9104C8.56698 0.9104 0.885986 8.59139 0.885986 18.0664C0.885986 27.5413 8.56698 35.2223 18.042 35.2223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9591 21.1857C28.9591 15.1559 24.0713 10.2678 18.0418 10.2678C12.0124 10.2678 7.12427 15.1559 7.12427 21.1857H10.2433C10.2433 16.8786 13.735 13.3874 18.0415 13.3874C22.3483 13.3874 25.8398 16.8786 25.8398 21.1857",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8218 26.1762C22.0949 26.1762 24.7483 23.5229 24.7483 20.2497C24.7483 16.9766 22.0949 14.3232 18.8218 14.3232C15.5486 14.3232 12.8953 16.9766 12.8953 20.2497C12.8953 23.5229 15.5486 26.1762 18.8218 26.1762Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.042 24.4606C21.5735 24.4606 24.4365 21.5977 24.4365 18.0661C24.4365 14.5345 21.5735 11.6716 18.042 11.6716C14.5104 11.6716 11.6475 14.5345 11.6475 18.0661C11.6475 21.5977 14.5104 24.4606 18.042 24.4606Z",
    fill: "url(#paint0_linear_88_2110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6381 10.2678C29.3445 1.62891 18.8607 -1.89347 10.2215 2.40009C7.5278 3.7389 5.2255 5.75066 3.5376 8.24053L10.5562 20.4054C9.26329 16.2975 11.5465 11.919 15.6544 10.6264C16.3769 10.399 17.1288 10.2783 17.8861 10.2681",
    fill: "url(#paint1_linear_88_2110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53751 8.24072C-1.83436 16.2541 0.307077 27.1044 8.32017 32.4763C10.7995 34.1382 13.6631 35.1374 16.6381 35.3785L23.9684 22.9014C21.2276 26.2233 16.3127 26.6944 12.9906 23.9533C11.8623 23.0227 11.0186 21.7934 10.5558 20.4059",
    fill: "url(#paint2_linear_88_2110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6382 35.3788C26.2581 36.1059 34.6458 28.8969 35.3731 19.2773C35.6078 16.1734 35.0087 13.0632 33.6378 10.2686H17.8861C22.1926 10.2882 25.6683 13.7957 25.648 18.1025C25.6401 19.845 25.0488 21.5346 23.9684 22.9017",
    fill: "url(#paint3_linear_88_2110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5376 8.2407L10.5562 20.4056C10.0362 18.6561 10.1464 16.7796 10.8675 15.1029L3.84922 7.77271",
    fill: "url(#paint4_linear_88_2110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6381 35.3787L23.9683 22.9016C22.8117 24.2807 21.2137 25.2174 19.4453 25.5527L16.3259 35.3787",
    fill: "url(#paint5_linear_88_2110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.638 10.2678H17.886C19.0573 10.2733 20.2123 10.5425 21.2653 11.0556C22.3183 11.5686 23.2421 12.3123 23.9683 13.2314L33.9501 10.7358",
    fill: "url(#paint6_linear_88_2110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_2110",
    x1: 18.0456,
    y1: 11.6615,
    x2: 18.0456,
    y2: 24.4612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81B4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5A94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_2110",
    x1: 18.5878,
    y1: 0.598124,
    x2: 18.5878,
    y2: 14.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF2227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_88_2110",
    x1: 4.82761,
    y1: 30.4825,
    x2: 12.0017,
    y2: 18.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#388B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CB749"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_88_2110",
    x1: 28.8605,
    y1: 31.7434,
    x2: 21.2183,
    y2: 13.3398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4B022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FCD209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_88_2110",
    x1: 7.20257,
    y1: 19.9379,
    x2: 7.20257,
    y2: 7.46108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_88_2110",
    x1: 24.4242,
    y1: 23.967,
    x2: 15.8464,
    y2: 32.7009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_88_2110",
    x1: 24.2999,
    y1: 26.4808,
    x2: 25.5478,
    y2: 14.1592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_2110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserChromeIcon);
export default __webpack_public_path__ + "static/media/browser_chromeIcon.edcd3a7b00c5172dbdd9fe375979f359.svg";
export { ForwardRef as ReactComponent };